export const state = () => ({
  media: {},
})

export const mutations = {
  setMedia(state, payload) {
    state.media = payload
  },
}

export const getters = {
  isMobile: state => state.media.isMobile,
  isLandscape: state => state.media.isLandscape,
  fromTablet: state => state.media.fromTablet,
  fromTabletH: state => state.media.fromTabletH,
  fromDesktop: state => state.media.fromDesktop,
  width: state => state.media.width,
}
